
<button (click)="exportTableExcel()">
    <img src="../../../../../../assets/icons/downloadIcon.svg" alt="Ícone de Download" />
    Exportar Excel
</button>